import { Observable } from 'rxjs';
import { OAuthProvider } from './model/o-auth-provider';

export interface IOAuthPopupService {
  openOrNavigateOAuthPopup(url: string, provider: OAuthProvider, closeOnLoadedMessage?: boolean): void;

  isNavigationInPopupPossible(): boolean;

  closedByUser(): Observable<unknown>;

  close(): void;
}
